import Vue from 'vue'
import Router from 'vue-router'
import store from 'vuex/store.js'

// Login
import Login2 from 'components/auth/Login2.vue'
/* import Login from 'components/auth/Login.vue' */
import Logout from 'components/auth/Logout.vue'
import Home from 'components/Home.vue'
// Monitoreo Servicios
import DashboardServices from 'components/dashboard/DashboardServices.vue'

// Carga
import ReceptionAppointments from 'components/reception/ReceptionAppointments.vue'
import ReceptionAppointmentsUpload from 'components/reception/ReceptionAppointmentsUpload.vue'
import DispatchAppointments from 'components/dispatch/DispatchAppointments.vue'
import DispatchAppointmentsUpload from 'components/dispatch/DispatchAppointmentsUpload.vue'
import Inventory from 'components/inventory/Inventory.vue'
import InventoryEntry from 'components/inventory/InventoryEntry.vue'
import InventoryDetail from 'components/inventory/InventoryDetail.vue'

// Monitoreo Documentos
import DocumentSearch from 'components/monitoring/DocumentSearch.vue'
import DocumentMonitoring from 'components/monitoring/DocumentMonitoring.vue'

// Reglas de Negocio
import AlertRules from 'components/rules/AlertRules.vue'
import AlertRulesEntry from 'components/rules/AlertRulesEntry.vue'

// Productos Perecibles
import PerishableProducts from 'components/products/perishable/PerishableProducts.vue'

// Avance de Pedidos
import OrdersProgress from 'components/orders/OrdersProgress.vue'
import OrdersProgressDetail from 'components/orders/OrdersProgressDetail.vue'

// InventoryProductStatus
import InventoryProductStatus from 'components/inventory/InventoryProductStatus.vue'

// DispatchTracking
import DispatchTracking from 'components/dispatch/DispatchTracking.vue'

/** Tracking Inicio Aurus - TI : WCR **/
import Tracking from 'components/tracking/Tracking.vue'
import TrackingNumber from 'components/tracking/TrackingNumber.vue'
import TrackingOrder from 'components/tracking/TrackingOrder.vue'
import OrderSearch from 'components/tracking/OrderSearch.vue'

Vue.use(Router)

const routes = [
  {
    path: '/Login',
    name: 'Login',
    component: Login2
  },
  {
    path: '/Logout',
    name: 'Logout',
    component: Logout
  },
  /** Inicio Aurus - TI : WCR **/
  {
    path: '/Tracking',
    name: 'Tracking',
    component: Tracking
  },
  {
    path: '/Tracking/:id',
    name: 'Tracking',
    component: Tracking
  },
  {
    path: '/Tracking/:id/:name',
    name: 'Tracking',
    component: Tracking
  },
  {
    path: '/TrackingNumber/:tracking',
    name: 'TrackingNumber',
    component: TrackingNumber
  },
  {
    path: '/TrackingNumber/:tracking/:name',
    name: 'TrackingNumber',
    component: TrackingNumber
  },
  {
    path: '/TrackingOrder/:order',
    name: 'TrackingOrder',
    component: TrackingOrder
  },
  {
    path: '/TrackingOrder/:order/:name',
    name: 'TrackingOrder',
    component: TrackingOrder
  },
  {
    path: '/TrackingOrder/:order/:acc',
    name: 'TrackingOrder',
    component: TrackingOrder
  },
  {
    path: '/TrackingOrder/:order/:name/:acc',
    name: 'TrackingOrder',
    component: TrackingOrder
  },
  /** Fin Aurus - TI **/
  {
    path: '/Home',
    name: 'Home',
    component: Home,
    meta: {
      auth: true
    }
  },
  {
    path: '/Monitoreo/Dashboard',
    name: 'ServiceMonitoring',
    component: DashboardServices,
    meta: {
      auth: true
    }
  },
  {
    path: '/Recepcion/Citas',
    name: 'ReceptionAppointments',
    component: ReceptionAppointments,
    meta: {
      auth: true
    }
  },
  {
    path: '/Recepcion/Citas/Carga/:accountCode',
    name: 'ReceptionAppointmentsUpload',
    component: ReceptionAppointmentsUpload,
    meta: {
      auth: true
    }
  },
  {
    path: '/Despacho/Citas',
    name: 'DispatchAppointments',
    component: DispatchAppointments,
    meta: {
      auth: true
    }
  },
  {
    path: '/Despacho/Citas/Carga/:accountCode',
    name: 'DispatchAppointmentsUpload',
    component: DispatchAppointmentsUpload,
    meta: {
      auth: true
    }
  },
  /** Inventory */
  {
    path: '/Inventario',
    name: 'Inventory',
    component: Inventory,
    meta: {
      auth: true
    }
  },
  {
    path: '/Inventario/Detalle/:period/:accountCode',
    name: 'InventoryDetail',
    component: InventoryDetail,
    meta: {
      auth: true
    }
  },
  {
    path: '/Inventario/Registro/:period/:accountCode?',
    name: 'InventoryEntry',
    component: InventoryEntry,
    meta: {
      auth: true
    }
  },
  {
    path: '/Inventario/Estado',
    name: 'InventoryProductStatus',
    component: InventoryProductStatus,
    meta: {
      auth: true
    }
  },
  /** Document Monitoring */
  {
    path: '/Documento/Busqueda',
    name: 'DocumentSearch',
    component: DocumentSearch,
    meta: {
      auth: true
    }
  },
  {
    path: '/Documento/Seguimiento',
    name: 'DocumentMonitoring',
    component: DocumentMonitoring,
    meta: {
      auth: true
    }
  },
  /** Inicio Aurus - TI : WCR **/
  {
    path: '/Documento/DocumentoEcommerce',
    name: 'EcommerceSearchDocuments',
    component: OrderSearch,
    meta: {
      auth: true
    }
  },
  /** Alter Rules */
  {
    path: '/Reglas/:accountCode?',
    name: 'AlertRules',
    component: AlertRules,
    meta: {
      auth: true
    }
  },
  {
    path: '/Reglas/Registro/:accountCode/:ruleCode?',
    name: 'AlertRulesEntry',
    component: AlertRulesEntry,
    meta: {
      auth: true
    }
  },
  /** Perishable Products */
  {
    path: '/ProductosPerecibles',
    name: 'PerishableProducts',
    component: PerishableProducts,
    meta: {
      auth: true
    }
  },
  /** Orders Progress */
  {
    path: '/AvancePedidos',
    name: 'OrdersProgress',
    component: OrdersProgress,
    meta: {
      auth: true
    }
  },
  /** Orders Progress Detail */
  {
    path: '/AvancePedidos/DetallePedido',
    name: 'OrdersProgressDetail',
    component: OrdersProgressDetail,
    meta: {
      auth: true
    }
  },
  /** Dispatch Tracking */
  {
    path: '/ServicioDistribucion',
    name: 'DispatchTracking',
    component: DispatchTracking,
    meta: {
      auth: true
    }
  }
]

const router = new Router({
  base: '/',
  mode: 'history',
  routes: routes,
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  $('#slider').removeClass('div-view')
  $('#slider').removeClass('div-display')
  $('.close-slider').removeClass('div-display')
  $('.main-header').removeClass('div-none')

  if (store.getters.loggedIn) {
    let link = routes.find(x => x.name === store.getters.userDefaultMenu.permission)
    let rou = routes.find(x => x.name === to.name)

    if ((to.name === undefined || rou === undefined) && to.name !== 'Login') {
      next(link.path)
    } else {
      if (to.name === 'Logout') {
        next()
      } else if (to.name === 'Login') {
        next(link.path)
      } else {
        let allow = false
        switch (to.name) {
          case 'InventoryDetail':
            if (store.getters.userPermissions['Inventory'] !== undefined && store.getters.userPermissions['Inventory'].length > 0) {
              allow = true
            }
            break
          case 'InventoryEntry':
            if (store.getters.userPermissions['Inventory'] !== undefined && store.getters.userPermissions['Inventory'].length > 0) {
              allow = true
            }
            break
          case 'ReceptionAppointmentsUpload':
            if (store.getters.userPermissions['ReceptionAppointments'] !== undefined && store.getters.userPermissions['ReceptionAppointments'].length > 0) {
              allow = true
            }
            break
          case 'DispatchAppointmentsUpload':
            if (store.getters.userPermissions['DispatchAppointments'] !== undefined && store.getters.userPermissions['DispatchAppointments'].length > 0) {
              allow = true
            }
            break
          default:
            if (store.getters.userPermissions[to.name] !== undefined && store.getters.userPermissions[to.name].length > 0) {
              allow = true
            } else {
              allow = true
            }
            break
        }

        if (allow) {
          next()
        } else {
          next(link.path)
        }
      }
    }
  } else {
    if (to.meta.auth) {
      next('Login')
    } else {
      if (to.path === '/' && to.name === null) {
        next('Login')
      } else {
        next()
      }
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js